import axios from '@/services'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import i18n from '@/i18n/i18n'
import { notify } from 'notiwind'

const checkRecaptcha = () => {
  const formStore = useFormStore()
  if (
    formStore?.activeForm?.config?.web?.isNeedRecaptcha &&
    !formStore.extraMap.recaptchaResponse
  ) {
    notify(
      {
        group: 'error',
        title: 'error',
        text: i18n.global.t('captchaNotProcessed')
      },
      6000
    )
    return false
  } else {
    return true
  }
}

const fileNumberAction = async (actionParams) => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  formStore.form.setTouched(true)
  const { valid, errors } = await formStore.form.validate()
  if (valid && checkRecaptcha()) {
    const {
      departmentCode = '',
      sequenceNumber = '',
      serviceCode = '',
      serviceYear = '',
      currentNationalityId = '',
      dateOfBirth = '',
      fileType = ''
    } = formStore.form.values || {}
    let fileNumberPayload = {
      departmentCode,
      sequenceNumber,
      serviceCode,
      serviceYear,
      currentNationalityId,
      dateOfBirth,
      fileType,
      serviceTransactionId: globalStore.startedService.serviceTransactionId,
      administrativeRegionId: 1
    }
    let fileNumberData = await axios.request({
      url: '/api/fines/draft/calculateFines',
      method: 'POST',
      data: fileNumberPayload
    })
    if (fileNumberData) {
      formStore.extraMap.showForm = true
      formStore.form.setValues({
        overstayDays: fileNumberData.overstayDays,
        finesAmount: fileNumberData.finesAmount
      })
    }
  }
}

const specialCaseSponsoredAction = async (actionParams) => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { fileType = '' } = formStore?.form?.values
  const validationResult = await formStore.form.validate()
  const {
    currentNationalityId = '',
    dateOfBirth = '',
    passportNumber = '',
    passportTypeId = ''
  } = formStore.form.values || {}
  const specialCaseSponsorePayload = {
    currentNationalityId,
    dateOfBirth,
    passportNumber,
    passportTypeId
  }
  if (checkRecaptcha()) {
    let specialCaseSponsoredData = await axios.request({
      url: '/api/guest/visa/validateVisaOnArrival',
      method: 'GET',
      params: specialCaseSponsorePayload
    })
    const {
      departmentCode = '',
      sequenceNumber = '',
      serviceCode = '',
      serviceYear = ''
    } = specialCaseSponsoredData
    const fileNumberPayload = {
      departmentCode,
      sequenceNumber,
      serviceCode,
      serviceYear,
      currentNationalityId,
      dateOfBirth,
      fileModuleId: fileType,
      serviceTransactionId: globalStore.startedService.serviceTransactionId,
      administrativeRegionId: '1'
    }
    if (specialCaseSponsoredData) {
      formStore.extraMap.userExist = true
      formStore.extraMap.showForm = true
      let fileNumberData = await axios.request({
        url: '/api/fines/draft/calculateFines',
        method: 'POST',
        data: fileNumberPayload
      })
      if (fileNumberData) {
        formStore.draft.request = {
          ...fileNumberData
        }
        formStore.form.setValues({
          responseDepartmentCode: fileNumberData.departmentCode,
          responseServiceYear: fileNumberData.serviceYear,
          responseServiceCode: fileNumberData.serviceCode,
          responseSequenceNumber: fileNumberData.sequenceNumber,
          overstayDays: fileNumberData.overstayDays,
          finesAmount: fileNumberData.finesAmount
        })
      }
    }
  }
}

export default function (actionName) {
  switch (actionName) {
    case 'finesSearch': {
      const formStore = useFormStore()
      const fileTypeVal = formStore?.form?.values?.fileType
      if (fileTypeVal === 1) {
        fileNumberAction()
      }
      if (fileTypeVal === 2) {
        specialCaseSponsoredAction()
      }
      break
    }
    default:
      break
  }
}
